import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { DollarSign, FileText, BookOpen } from 'lucide-react';

interface RecordJournalTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const RECORD_TYPES = [
  { value: 'Private Contribution Received', label: 'Private Contribution Received', icon: DollarSign, description: 'Record a contribution received from a member or external party' },
  { value: 'Grant or Distribution Made', label: 'Grant or Distribution Made', icon: DollarSign, description: 'Document a grant or distribution to a beneficiary' },
  { value: 'Expense Payment', label: 'Expense Payment', icon: FileText, description: 'Log an expense payment to a vendor or service provider' },
  { value: 'Activity Log Entry', label: 'Activity Log Entry', icon: BookOpen, description: 'Create an activity record for general documentation' },
  { value: 'General Record', label: 'General Record', icon: FileText, description: 'File a general record for future reference' },
];

export function RecordJournalTypeSelect({ value, onChange }: RecordJournalTypeSelectProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Select Record Type</CardTitle>
        <CardDescription>Choose the type of record you want to create. Each type collects specific information relevant to that transaction.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        {RECORD_TYPES.map((type) => {
          const Icon = type.icon;
          const isSelected = value === type.value;
          return (
            <div
              key={type.value}
              className={`flex items-start gap-3 p-4 border rounded-lg cursor-pointer transition-colors ${
                isSelected ? 'border-primary bg-primary/5' : 'hover:border-muted-foreground/50'
              }`}
              onClick={() => onChange(type.value)}
            >
              <div className={`p-2 rounded-lg ${isSelected ? 'bg-primary/10' : 'bg-muted'}`}>
                <Icon className={`h-5 w-5 ${isSelected ? 'text-primary' : 'text-muted-foreground'}`} />
              </div>
              <div className="flex-1">
                <p className={`font-medium ${isSelected ? 'text-primary' : ''}`}>{type.label}</p>
                <p className="text-sm text-muted-foreground">{type.description}</p>
              </div>
              {isSelected && <Badge variant="default">Selected</Badge>}
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}

export { RECORD_TYPES };
